import { environment } from '../../../environments/environment';

export const profileSetting = [
  {
    cardTitle: 'Admin Portal',
    cardDescription: 'Founder & CEO',
    imageSource: 'assets/caregenix/images/Admin-Portal.png',
    isActive: 'admin',
  },
  {
    cardTitle: 'Patient Onboarding',
    cardDescription: 'For onboarding patients',
    imageSource: 'assets/caregenix/images/patient-Portal.png',
    isActive: 'patientOnBoarding',
    ...(environment.onboardingRedirectUrl
      ? { externalUrl: environment.onboardingRedirectUrl }
      : {}),
  },
  {
    cardTitle: 'Patient Portal',
    cardDescription: "For managing patient's data",
    imageSource: 'assets/caregenix/images/patient-Portal.png',
    isActive: 'patient',
  },
  {
    cardTitle: 'Care Portal',
    cardDescription: 'For care managers to manage patients',
    imageSource: 'assets/caregenix/images/Care-Management.png',
    isActive: 'care',
  },
  {
    cardTitle: 'Billing Portal',
    cardDescription: 'For billing management',
    imageSource: 'assets/caregenix/images/Billing-Portal.png',
    isActive: 'billing',
  },
  {
    cardTitle: 'Provider Portal',
    cardDescription: 'For providers',
    imageSource: 'assets/caregenix/images/Dr-Portal.png',
    isActive: 'doctor',
  },
  {
    cardTitle: 'Reporting Portal',
    cardDescription: 'For analytical reports',
    imageSource: 'assets/caregenix/images/Reportingportalicon.png',
    isActive: 'reporting',
  },
  {
    cardTitle: 'Microservice',
    cardDescription: 'For micro-service calls',
    imageSource: 'assets/caregenix/images/Reportingportalicon.png',
    isActive: 'microservice',
  },
  {
    cardTitle: 'Demo Portal',
    cardDescription: 'For AI services',
    imageSource: 'assets/caregenix/images/Reportingportalicon.png',
    isActive: 'demoportal',
  },
  {
    cardTitle: 'SDOH Portal',
    cardDescription: 'For SDOH services',
    imageSource: 'assets/caregenix/images/Reportingportalicon.png',
    isActive: 'sdoh',
  },
  {
    cardTitle: 'Logistic Portal',
    cardDescription: 'For Logistic services',
    imageSource: 'assets/caregenix/images/Reportingportalicon.png',
    isActive: 'logistic',
  },
  {
    cardTitle: 'Secure Portal',
    cardDescription: 'For Patients',
    imageSource: 'assets/caregenix/images/patient-Portal.png',
    isActive: 'secure',
  },
  {
    cardTitle: 'Population Health Portal',
    cardDescription: 'For Population Health Analytics',
    imageSource: 'assets/caregenix/images/Reportingportalicon.png',
    isActive: 'health',
  },
  {
    cardTitle: 'Population Health Portal (S3)',
    cardDescription: 'For old Population Health Analytics',
    imageSource: 'assets/caregenix/images/Reportingportalicon.png',
    isActive: 'healthS3',
  },
  {
    cardTitle: 'Analysis Dashboard',
    cardDescription: 'For Admissions Analysis',
    imageSource: 'assets/caregenix/images/Reportingportalicon.png',
    isActive: 'analysis',
  },
  {
    cardTitle: 'Patients Profile Portal',
    cardDescription: 'For Patients Profile Management',
    imageSource: 'assets/caregenix/images/patient-Portal.png',
    isActive: 'patientAnalytics',
    externalUrl: 'https://dashboards.carevance.solutions/patient-profiling/',
  },
];
